import { handleActions } from 'redux-actions';
import NotificationsActions from '../actions/NotificationsCRUDActions';
import NotificationModel from '../model/NotificationModel';
import { NotificationsState } from '../interfaces/notifications';

type ActionType = {
  type: string;
  entities: NotificationModel[];
  snoozed: boolean;
  payload: any; // unused - added for TS
};

const initialState: NotificationsState = {
  snoozed: false,
  busy: false,
  entities: [],
};

const retrievedAll = (state: NotificationsState, action: ActionType) => {
  const { entities, snoozed } = action;

  return { ...state, busy: false, entities, snoozed };
};

const mappedReducers = {
  [NotificationsActions.notificationsRetrievedAction]: retrievedAll,
  [NotificationsActions.notificationsSnoozedAction]: (
    state: NotificationsState,
  ) => ({ ...state, snoozed: true }),
};

export default handleActions(mappedReducers, initialState);
